<template>
  <div>
    <p style="text-align: center">
      <!-- 销售人员查询 -->
      <span class="systemFont1">{{ $t("salespersonMgt.title") }}</span>
    </p>
    <el-row>
      <div style="display: inline-block;" class="main">
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryFormRef"
          label-width="120px"
          style="width:100%;"
          class="systemFont1"
        >
          <el-col :span="1">
            <!-- 新增 -->
            <el-button class="submitButton" type="submit" @click="addSalesperson()">{{
              $t("common.new")
            }}</el-button>
          </el-col>
          <el-col :span="8" :offset="1">
            <!-- 个人用户检索入力框 -->
            <el-form-item
              :label="$t('salespersonMgt.personalUser')"
              prop="queryCriteria"
            >
              <el-input
                type="text"
                size="small"
                maxlength="60"
                v-model="queryForm.queryCriteria"
                clearable
                :placeholder="$t('salespersonMgt.searchPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <!-- 关联公司 -->
            <el-form-item
              :label="$t('salespersonMgt.queryExistingCo')"
              prop="queryExistingCo"
            >
              <el-input
                type="text"
                size="small"
                maxlength="60"
                v-model="queryForm.queryExistingCo"
                clearable
                :placeholder="$t('salespersonMgt.fuzzySearch')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col style="width: 200px;">
            <!-- 查询 -->
            <el-button class="submitButton" type="submit" style="margin-left:10px" @click="getSalesperson(true)">{{
              $t("common.query")
            }}</el-button>
            <!-- 重置 -->
            <el-button type="submit" class="buttonWidth" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-form>
      </div>
      <el-col :span="22" :offset="1">
        <el-row><br /></el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1">
        <el-table
          ref="salesDetailTable"
          :data="salesPersonData"
          v-loading="pageLoading"
          tooltip-effect="dark"
        >
          <!-- 姓名-->
          <el-table-column
            prop="name"
            :label="$t('salespersonMgt.nameZh')"
            align="left"
            min-width="160px"
            fixed="left"
          ></el-table-column>
          <!-- 英文姓名-->
          <el-table-column
            prop="nameEn"
            :label="$t('salespersonMgt.nameEn')"
            align="left"
            min-width="160px"
          ></el-table-column>
          <!-- 昵称-->
          <el-table-column
            prop="nickname"
            :label="$t('salespersonMgt.nickname')"
            align="left"
            min-width="120px"
          ></el-table-column>
          <!-- 注册邮箱-->
          <el-table-column
            prop="registerEmail"
            :label="$t('salespersonMgt.registerEmail')"
            align="left"
            min-width="220px"
          ></el-table-column>
          <!-- 注册手机-->
          <el-table-column
            prop="registerPhone"
            :label="$t('salespersonMgt.registerPhone')"
            align="center"
            min-width="136px"
          ></el-table-column>
          <!-- 管理用户数量-->
          <el-table-column
            prop="manageUserNum"
            :label="$t('salespersonMgt.manageUserNum')"
            align="right"
            min-width="120px"
          ></el-table-column>
          <!-- 关联公司-->
          <el-table-column
            prop="existingCompany"
            :label="$t('salespersonMgt.existingCompany')"
            align="left"
            min-width="265px"
          ></el-table-column>
          <!-- 职位-->
          <el-table-column
            prop="position"
            :label="$t('salespersonMgt.position')"
            align="left"
            min-width="180px"
          ></el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('common.operation')"
            align="center"
            min-width="224px"
            fixed="right"
            >
            <template slot-scope="scope">
              <el-button size="text" @click="openUserMgt(scope.row)">{{
                $t("salespersonMgt.managementUser")
              }}</el-button>
              <el-button size="text" @click="gotoUserDetails(scope.row)">{{
                $t("common.details")
              }}</el-button>
              <el-button size="text" @click="cancelSaleQualify(scope.row)">{{
                $t("salespersonMgt.cancelSaleQualify")
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px 60px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 管理用户弹框 -->
    <el-dialog
      :title="$t('salespersonMgt.mgtUserTitle')"
      class="add_roll-dialog"
      :close-on-click-modal="false"
      width="70%"
      :visible.sync="isOpenMgtUserDialog"
      :before-close="closeUserMgt"
    >
      <p0432 ref="p0432Ref" :salesPerson="salePersonUserId"></p0432>
    </el-dialog>
    <!-- 新增销售人员弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      class="add_roll-dialog"
      :title="$t('salespersonMgt.addSaleTitle')"
      width="70%"
      :visible.sync="isOpenAddSaleDialog"
      :before-close="closeAddSaleDialog"
    >
      <p0438 ref="p0438Ref" :pageNo="1" :marketingUserWatch="marketingUserWatch"></p0438>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
import p0432 from '../../Marketing/MarketingMgt/P0432';
import p0438 from '../../Marketing/MarketingMgt/commonPg/P0438';
export default {
  data() {
    return {
      // 页面载入状态
      pageLoading: false,
      // 销售人员新增刷新判断
      marketingUserWatch: false,
      // 新增销售人员弹框打开flg
      isOpenAddSaleDialog: false,
      // 管理用户弹框打开flg
      isOpenMgtUserDialog: false,
      // 被选择的销售人员ID
      salePersonUserId: "",
      // 销售人员一览数据
      salesPersonData: [],
      // 查询条件
      queryForm: {
        queryCriteria: "",
        queryExistingCo: ""
      },
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 10,
      // 总数
      total: 0,
      // 检索条件保持变量
      tmpQueryStr: {
        queryCriteria: "",
        queryExistingCo: ""
      }
    };
  },
  components: {
    p0432,
    p0438
  },
  methods: {
    // 销售人员一览取得
    getSalesperson(val) {
      this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
        this.tmpQueryStr = this.queryForm;
      }
      // 换页时，检索条件还原
      this.queryForm = this.tmpQueryStr;
      // 销售人员一览取得
      let url = "/api/salespersonMgt/getSalespersonList";
      this.$http
        .post(
          url,
          qs.stringify({
            ...this.queryForm,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.salesPersonData = response.data.data;
            this.total = this.salesPersonData.length > 0 ? this.salesPersonData[0].total : 0;
          } else {
            this.salesPersonData = [];
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 重置检索条件
    reset() {
      this.$refs.queryFormRef.resetFields();
      this.getSalesperson(true);
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.salesPersonData == undefined ||
        this.salesPersonData.length <= 0
      ) {
        return;
      }
      this.getSalesperson(false);
      // console.log(`每页 ${val} 条`);
    },
    // 新增培训师
    addSalesperson() {
      // 刷新弹窗
      this.marketingUserWatch = !this.marketingUserWatch;
      this.isOpenAddSaleDialog = true;
    },
    // 新增销售人员弹窗关闭
    closeAddSaleDialog() {
      this.isOpenAddSaleDialog = false;
      this.getSalesperson(true);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSalesperson(false);
      // console.log(`当前页: ${val}`);
    },
    // 打开管理用户弹框
    openUserMgt(rowVal) {
      this.isOpenMgtUserDialog = true;
      // 参数（userId)设定
      this.salePersonUserId = rowVal.salesPerson;
      // 调用子页面方法
      this.$nextTick(()=>{
        this.$refs.p0432Ref.getMgtUserList(true);
      });
    },
    // 关闭管理用户弹窗，清除数据
    closeUserMgt() {
      this.isOpenMgtUserDialog = false;
      // 调用子页面方法
      this.$nextTick(()=>{
        this.$refs.p0432Ref.resetUserMgt();
      });
      this.getSalesperson(false);
    },
    // 跳转到用户详细画面
    gotoUserDetails(rowVal) {
      // 用户ID和当前页记录
      let p0212 = JSON.stringify({
        userID: rowVal.salesPerson,
        currentPage: this.currentPage
      });
      sessionStorage.p0212 = p0212;
      // 分页相关变量记录
      sessionStorage.setItem("total", this.total);
      sessionStorage.setItem("pageSize", this.pageSize);
      let query = JSON.stringify({
        queryCriteria: this.tmpQueryStr.queryCriteria,
        queryExistingCo: this.tmpQueryStr.queryExistingCo
      });
      // 检索条件记录
      sessionStorage.setItem("queryCriteria", query);
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    //返回跳转前的页面
    getSchoolWebModuleMessageListFunc() {
      //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if (sessionStorage.getItem("detail")) {
        //如果有这个就读取缓存里面的数据
        this.currentPage = Number(sessionStorage.getItem("currentPage"));
        this.total = Number(sessionStorage.getItem("total"));
        this.pageSize = Number(sessionStorage.getItem("pageSize"));
        this.tmpQueryStr = JSON.parse(sessionStorage.getItem("queryCriteria"));
        this.getSalesperson(false);
        sessionStorage.removeItem("detail");
      } else {
        this.currentPage = 1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
        sessionStorage.removeItem("total");
      }
    },
    // 取消销售资格
    cancelSaleQualify(rowVal) {
      // 取消销售资格提示
      this.$confirm(this.$t("salespersonMgt.cancelQualifyConfirm"), {
        // 确定
        confirmButtonText: this.$t("common.confirm"),
        // 取消
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      }).then(() => {
          // 取消销售资格
          let url = "/api/salespersonMgt/cancelSaleQualify";
          this.$http
          .post(
            url,
            qs.stringify({
              salesPerson: rowVal.salesPerson,
              updateUser: localStorage.getItem("userId")
            })
          )
          .then(response => {
            console.log(response.data);
            if (response.data.code === 200) {
              if(this.salesPersonData.length > 1) {
                // 该页数据超过一件时，重新筛选当页数据
                this.getSalesperson(false);
              } else {
                // 该页数据仅一件时，重新从第一页筛选数据
                this.getSalesperson(true);
              }
              this.$message.success(response.data.data);
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(err => {
            console.log(err);
            this.$message.error(this.$t("common.anErrorOccurred"));
          });
        }).catch(() => {});
    },
    // 新增销售人员弹框打开

  },
  mounted() {
    if (sessionStorage.getItem("detail")) {
      this.getSchoolWebModuleMessageListFunc();
    } else {
      this.getSalesperson(true);
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
.submitButton {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-tabs__item {
  font-size: 15px;
}
>>>.el-divider--horizontal{
  margin: 14px 0;
}
>>> .add_roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(90vh - 160px);
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/P0431.vue